export {repartirPorBase} from '../../../../utils/calculo-dte'

export const formatearDolares = (valor: number): string =>
  (isNaN(valor) ? 0 : valor).toLocaleString('es-SV', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'USD',
  })
